module.exports = __webpack_public_path__ + "img/start.5492d151.png";